import { useCallback, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { clearApolloCache } from './apollo'
import { clearTokens } from './tokens'

export const useLogin = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const navigateToLogin = useCallback(
    (redirect = true) => {
      navigate(getLoginUrl(redirect ? location : undefined))
      clearTokens()
      clearApolloCache()
    },
    [navigate, location]
  )

  return useMemo(() => ({ navigateToLogin }), [navigateToLogin])
}

export const getLoginUrl = (location?: {
  pathname: string
  search: string
  hash: string
}) => {
  const uri = '/login'
  if (!location) {
    return uri
  }
  const redirectTo = [location.pathname, location.search, location.hash].join(
    ''
  )
  return redirectTo === '/'
    ? uri
    : `${uri}?redirectTo=${encodeURIComponent(redirectTo)}`
}
